import { normalize } from 'normalizr'
import { Schemas } from 'redux-modules/schema'
import { updateEntities, deleteEntity } from 'redux-modules/entity'

import api from 'api'

const CREATE_REQUEST = 'realhub/orderTrackingCode/CREATE_REQUEST'
const CREATE_SUCCESS = 'realhub/orderTrackingCode/CREATE_SUCCESS'
const CREATE_FAILURE = 'realhub/orderTrackingCode/CREATE_FAILURE'

const DELETE_REQUEST = 'realhub/orderTrackingCode/DELETE_REQUEST'
const DELETE_SUCCESS = 'realhub/orderTrackingCode/DELETE_SUCCESS'
const DELETE_FAILURE = 'realhub/orderTrackingCode/DELETE_FAILURE'

// Initial State
const initialState = {
  creating: false,
  errors: [],
}

// Actions

export function createRequest(){
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess(){
  return {
    type: CREATE_SUCCESS,
  }
}

export function createFailure(errors = []){
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function deleteRequest(){
  return {
    type: DELETE_REQUEST,
  }
}

export function deleteSuccess(){
  return {
    type: DELETE_SUCCESS,
  }
}

export function deleteFailure(errors = []){
  return {
    type: DELETE_FAILURE,
    errors,
  }
}

// Helper Functions
const handleError = errors => errors || ['Something went wrong']

export function createOrderTrackingCode(orderTrackingCode, options, callback){
  const config = {
    method: 'POST',
    body: JSON.stringify({
      order_tracking_code: orderTrackingCode,
    }),
  }

  return (dispatch) => {
    dispatch(createRequest())

    const promise = api(`/admin/orders/${orderTrackingCode.order_id}/order_tracking_codes.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.ORDER_TRACKING_CODE)
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess())

        if (callback) callback(json)

        return json
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(createFailure(errors))
      })

    return promise
  }
}

export function bulkDeleteOrderTrackingCodes(options, callback){
  const config = {
    method: 'DELETE',
  }

  return (dispatch) => {
    dispatch(deleteRequest())

    const promise = api('/admin/order_tracking_codes/bulk_delete.json', options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        if (json.ids){
          json.ids.forEach((id) => {
            const normalizedJson = normalize({ id }, Schemas.ORDER_TRACKING_CODE)
            dispatch(deleteEntity(normalizedJson))
          })
        }

        dispatch(deleteSuccess())

        if (callback) callback(json)

        return json
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(deleteFailure(errors))
      })
    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case CREATE_REQUEST:
      return {
        ...state,
        creating: true,
      }
    case CREATE_SUCCESS:
      return {
        ...state,
        creating: false,
        errors: [],
      }
    case CREATE_FAILURE:
      return {
        ...state,
        creating: false,
        errors: action.errors,
      }
    default:
      return state
  }
}
